/**
 * Normalize leftover GoTrue session storage from older Identity clients.
 *
 * Absolute production Identity URLs in `gotrue.user` would make token refresh
 * hit a cross-origin Identity host from the browser (CORS fails on X-Nf-Client).
 * Keep the session URL on the same origin; Vite proxies /.netlify/identity.
 */
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

function isProductionIdentityUrl(url: string): boolean {
  return /https?:\/\/[^/]*netlify\.app\/\.netlify\/identity/i.test(url)
    || /https?:\/\/momotrading\.netlify\.app\/?$/i.test(url);
}

export function prepareIdentityStorage(): void {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return;

  try {
    // Drop stale Site URL pins left by netlify-identity-widget.
    const site = localStorage.getItem('netlifySiteURL');
    if (site && (LOCAL_HOSTS.has(window.location.hostname) || isProductionIdentityUrl(site))) {
      localStorage.removeItem('netlifySiteURL');
    }

    const raw = localStorage.getItem('gotrue.user');
    if (!raw) return;
    const parsed = JSON.parse(raw) as { url?: unknown };
    if (typeof parsed.url !== 'string' || !isProductionIdentityUrl(parsed.url)) return;

    parsed.url = `${window.location.origin}/.netlify/identity`;
    localStorage.setItem('gotrue.user', JSON.stringify(parsed));
  } catch {
    // Ignore storage / parse errors.
  }
}

prepareIdentityStorage();
